import(/* webpackMode: "eager" */ "/app/src/app/[locale]/Commerce-Hospitality/page.tsx");
